import Modal from "../../ui-components/Modal";
import getUserPermissions from "../../utils/getUserPermissions";
import WorksiteImageUploader from "../WorksiteImageUploader";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import _ from "lodash";

function WorksiteUploadImageModal({
  closeModal,
  selectedWorksite,
  setSelectedWorksite,
  worksiteImageData,
  setWorksiteImageData,
  toggleNewWorksiteUploadImageDialog,
}) {
  // console.log("WorksiteUploadImageModal worksiteImageData", worksiteImageData);
  const apiRequest = useCountryAxiosInstance();

  const perm = getUserPermissions();

  const updateWorksiteWithImages = async () => {
    if (selectedWorksite) {
      let tmp = {
        ...selectedWorksite,
        images_urls: {
          data: [...worksiteImageData.map((img) => _.pick(img, ['image_url', 'des_image']))],  // exclude loadedOn property before saving
        },
      };
      const data = await apiRequest.put(
        `/worksites/${selectedWorksite.id}`,
        tmp
      );
      setSelectedWorksite(data);
      toggleNewWorksiteUploadImageDialog();
      setWorksiteImageData([...worksiteImageData]);
    }
  };

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full items-center justify-center">
        <div className="w-full mb-4 flex justify-center">
          <WorksiteImageUploader
            setImagesData={setWorksiteImageData}
            imagesData={worksiteImageData}
            userId={perm}
            saveImages={updateWorksiteWithImages}
          />
        </div>
      </div>
    </Modal>
  );
}

export default WorksiteUploadImageModal;
